import { Icon } from '@chakra-ui/react';

export const UpGraphIcon = (props) => (
  <Icon viewBox="0 0 12 8" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M0.457266 7.20693C0.684766 7.43443 1.05227 7.43443 1.27977 7.20693L3.95727 4.52943C4.18477 4.30193 4.55227 4.30193 4.77977 4.52943L5.46227 5.21193C6.14477 5.89443 7.2531 5.89443 7.9356 5.21193L10.3739 2.77943L11.2139 3.61943C11.3948 3.80026 11.7098 3.67193 11.7098 3.41526V0.91276C11.7156 0.749427 11.5873 0.621094 11.4239 0.621094H8.92143C8.65893 0.621094 8.5306 0.936094 8.71727 1.11693L9.55727 1.95693L7.12477 4.38943C6.89727 4.61693 6.52977 4.61693 6.30227 4.38943L5.61977 3.70693C4.93727 3.02443 3.82893 3.02443 3.14643 3.70693L0.457266 6.38443C0.235599 6.61193 0.235599 6.98526 0.457266 7.20693Z"
      fill="#666666"
    />
  </Icon>
);
